import { combineReducers } from 'redux';
import auth from './auth';
import user from './user';
import team from './team';
import teamBadges from './teamBadges';
import EasterEgg from './easterEggs';
import { notifications } from 'components/Toast';

const RootReducer = combineReducers({
	auth,
	user,
	team,
	teamBadges,
	EasterEgg,
	notifications,
});

export default RootReducer;
